// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___st86R";
export { _1 as "container" }
